import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Time helpers (milliseconds)
const SECOND = 1000;
const MINUTE = 60 * SECOND;

/**
 * ------------
 * Stale times define how long cached query data is considered “fresh”.
 */
const DEFAULT_STALE = 60 * SECOND;

/**
 * QUERY_DEFAULTS
 * ---------------------
 * Default TanStack Query options applied across app hooks.
 * Hooks should spread this into `useQuery` options.
 */
const QUERY_DEFAULTS = {
  staleTime: DEFAULT_STALE,

  // TanStack Query v5: gcTime replaces cacheTime
  gcTime: 30 * MINUTE,

  retry: 0,
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
  refetchOnMount: false,
};

/**
 * ReactQueryProvider – wraps the app with a configured QueryClient.
 * @param {{children: import('react').ReactNode}} props
 */
export const ReactQueryProvider = ({ children }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { ...QUERY_DEFAULTS},
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
